import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "paticipant__full-name__edit-button d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "paticipant__full-name d-flex d-flex gap-1 align-items-center" }

import { computed, ComputedRef, Ref, ref } from 'vue'

  // Types
  import { TravellerSummary } from '@/services/BookingService.interface'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Icons
  import ArrowRightIcon from '@/assets/ArrowRightIcon.vue'

  // Utils
  import { getAge } from '@/utils'

  // Components
  import Card from '@/components/UI/Card.vue'
  import Button from '@/components/UI/Button.vue'
  import CheckMark from './CheckMark.vue'
  import EdittravellerPanel from './EditTravellerPanel.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  import { useStore } from '@/store'
  interface Props {
    traveller: TravellerSummary
    travellerIndex: number
    departureDate?: string
    panelMode?: boolean
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Traveller',
  props: {
    traveller: {},
    travellerIndex: {},
    departureDate: {},
    panelMode: { type: Boolean }
  },
  setup(__props: any) {

  // Vue
  const { t } = useI18n()

  // Store
  const store = useStore()

  // Props
  const props = __props

  // Refs
  const selectedTraveller: Ref<TravellerSummary | null> = ref(null)

  // Methods
  const handleOpenEditPanel = (traveller: TravellerSummary): void => {
    if (!props.panelMode) return
    selectedTraveller.value = traveller
    store.commit('modal/open', panelId.value)
  }

  const truncateText = (text: string, length = 28) => {
    return text.length > length ? text.substring(0, length) + '...' : text
  }

  const getDisplayName = (name: string | null, fallback: string): string => {
    if (!name) {
      return fallback
    }
    return name
  }

  const ageDisplayClass = computed(() => {
    return props.panelMode ? 'd-block' : 'd-inline'
  })

  // Computed
  const age: ComputedRef<string> = computed(() => {
    const computedAge: string = getAge(
      props.traveller.birthday,
      props.departureDate
    )
    const ageString = `${computedAge} ${t('travellers.yearsOld')}`
    return props.panelMode ? ageString : `(${ageString})` // wrapper in parentheses if not in panel
  })

  const firstName: ComputedRef<string> = computed(() => {
    return truncateText(
      getDisplayName(
        props.traveller?.firstName,
        props.panelMode ? t('travellers.traveller') : t('travellers.firstName')
      )
    )
  })

  const lastName: ComputedRef<string> = computed(() => {
    return truncateText(
      getDisplayName(
        props.traveller?.lastName,
        props.panelMode
          ? (props.travellerIndex + 1).toString()
          : t('travellers.lastName')
      )
    )
  })

  const panelId: ComputedRef<string> = computed(() => {
    return `${ModalId.EDIT_TRAVELLER_PANEL}-${selectedTraveller.value?.id}`
  })

  const dataFulfilled: ComputedRef<boolean> = computed(() => {
    return !!(props.traveller.firstName && props.traveller.lastName)
  })

  // CSS classes
  const nameTextClasses: ComputedRef<string> = computed(() => {
    const baseClass = 'text-capitalize'

    const textClasses = props.panelMode ? 'heading' : 'body'
    return `${baseClass} ${textClasses}`
  })

  const cardAdditionalClasses: ComputedRef<string> = computed(() => {
    const baseClasses = 'traveller  d-flex shadow-none padding-none gap-1'

    const additionalClasses = props.panelMode
      ? 'cursor-pointer flex-column  px-3'
      : 'py-none border-0 flex-row'
    return `${baseClasses} ${additionalClasses}`
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    "additional-classes": cardAdditionalClasses.value,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOpenEditPanel(_ctx.traveller)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["paticipant__first-name text-capitalize", nameTextClasses.value])
          }, _toDisplayString(firstName.value), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["paticipant__last-name text-capitalize", nameTextClasses.value])
          }, _toDisplayString(lastName.value), 3),
          (dataFulfilled.value)
            ? (_openBlock(), _createBlock(CheckMark, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["paticipant__age", ageDisplayClass.value])
          }, _toDisplayString(age.value), 3)
        ]),
        (_ctx.panelMode)
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              classes: ['btn']
            }, {
              svg: _withCtx(() => [
                _createVNode(ArrowRightIcon)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (selectedTraveller.value)
        ? (_openBlock(), _createBlock(EdittravellerPanel, {
            key: 0,
            selectedTraveller: selectedTraveller.value,
            panelTitle: `${firstName.value} ${lastName.value}`,
            panelId: panelId.value
          }, null, 8, ["selectedTraveller", "panelTitle", "panelId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["additional-classes"]))
}
}

})